import React, { Component } from "react";
import { connect } from "react-redux";
import { axiosUserManagement } from "../../axios";
import HelmetComponent from "../../components/shared/Helmet";
import { MetaContent } from "../../constants/constant";

import { SiteConstants } from "../../constants/constant";
import SignupEmail from "../../components/forms/Signup/SignupEmail";
import SignupPreferencesConfig from "../../components/formsConfig/SignupPreferencesConfig";
import {
  setToken,
  setUser,
  showLoader,
  hideLoader,
} from "../../actions";
import { analytics } from "../../analytics";
import { handleActionError } from "../../util/error";

class SignUpComplete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: SiteConstants.SignupPreferences,
      propsStep: SiteConstants.SignupPreferences,
      signUpDropdown: null,
      ...{ SignupPreferencesConfig },
      btnDisabled: true,
      message: null,
      success: false
    };
  }


  ResendEmailHandler = formName => {
    event.preventDefault();
    const formData = {
      email: this.props.signUpFrom.email
    };
    this.props.showLoader();
    axiosUserManagement
      .post("/resend/email", formData, {
        "cache-control": "no-cache",
        "content-type": "application/json"
      })
      .then(res => {
        this.setState({
          success: true,
          message: res.data.message
        });
        this.props.hideLoader();
      })
      .catch(err => {
        handleActionError("Error resending email:", err);
        this.setState({
          message: err.response.data.message
        });
        this.props.hideLoader();
      });
  };

  render() {
    return (
      <React.Fragment>
        <HelmetComponent
          title={MetaContent.signup.title}
          description={MetaContent.signup.description}
          noIndex="false"
        />
        <div className="background">
          <div className="container">
            <div className="row">
              <div className="col-12 no-gutter-col">
                <div className="signInUpFlow">
                    <SignupEmail
                      sucessHandler={this.ResendEmailHandler}
                      message={this.state.message}
                    />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    provider: state.auth.provider,
    signUpFrom: state.signup.signUpForm,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token)),
    showLoader: () => dispatch(showLoader()),
    hideLoader: () => dispatch(hideLoader()),
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(SignUpComplete)
};
